module.exports = __webpack_public_path__ + "media/mono/default-32747f6a.svg";